import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, Dictionary, Group, ISortConfiguration } from '../../../models';
import { ILoggerService, IGroupSelectionService, IGroupService } from '../../../services';
import { seriesAdded, toDictionary, wtDroppableDrop } from '../../../common';
import { GroupWithPath } from '../../../widgets';
import { GroupStateConfiguration } from '../groupStates.configuration';

interface Row {
    viewModel: Group;
    series: GroupStateConfiguration;
}

class GroupStatesSeriesController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    series: GroupStateConfiguration[];
    isBindable: boolean;
    tuples: Row[];
    sortConfig: ISortConfiguration;

    private _allGroups: Dictionary<GroupWithPath>;

    static $inject = [
        '$scope',
        'groupService',
        'loggerService',
        'groupSelectionService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _groupService: IGroupService,
        private _loggerService: ILoggerService,
        private _groupSelectionService: IGroupSelectionService
    ) {
        this.sortConfig = {
            animation: 150,
            handle: '.drag-handle',
            onSort: evt => this.sort(evt)
        };
    }

    $onInit() {
        this._$scope.$on(seriesAdded, (event, data) => this.add(data));

        this._$scope.$on(wtDroppableDrop, (event, data) => {
            if (data.itemId) {
                const groupGuid = data.itemId.replace('group', '');
                const oldGroupGuid = data.binId ? data.binId : undefined;
                this.drop(groupGuid, oldGroupGuid);
            }
        });

        this._$scope.$watch(() => this.series, newValue => {
            if (newValue) {
                this.updateTuples();
            }
        }, true);
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['groups']?.currentValue) {
            this._allGroups = toDictionary(changesObj['groups'].currentValue);
            this.updateTuples();
        }
    }

    remove(series) {
        _.remove(this.series, s => s.guid === series.guid);
    }

    private sort(evt) {
        evt.models.forEach((s, i) => s.series.sortOrder = i);
        this.series = evt.models.map(d => d.series);
    }

    private updateTuples() {
        if (this.series && this._allGroups) {
            this.tuples = this.series.map(d => {
                return {
                    viewModel: this._allGroups[d.guid],
                    series: d
                };
            });
        }
    }

    private drop(groupGuid: string, oldGroupGuid?: string) {

        const group = this._allGroups[groupGuid];
        this._groupService
            .getPaths([group.guid])
            .then(d => {
                group.path = d[0].path;
                this.add(group, oldGroupGuid);
            });
    }

    private add(group: GroupWithPath, guidToReplace?: string) {
        if (_.every(this.series, state => state.guid !== group.guid)) {
            if (guidToReplace) {
                const old = _.find(this.series, s => s.guid === guidToReplace);
                old.guid = group.guid;
                old.name = group.name;
                old.originalGuid = group.guid;
                // isBoundToGroup keep the old values
            } else {
                const selectedGroup = this.isBindable ? this._groupSelectionService.selectedGroup() : null;
                const isChild = selectedGroup && group.path.indexOf((<any>selectedGroup).absolutePath) >= 0;
                this.series.push({
                    guid: group.guid,
                    isBoundToGroup: isChild,
                    name: group.name,
                    hasComment: true,
                    hasType: true,
                    originalGuid: group.guid,
                    value: ''
                });
            }
        } else {
            this._loggerService.logWarning('This group already exists', true);
        }
    }
}

export const wtGroupStatesSeries: ComponentDefinition = {
    componentId: 'wtGroupStatesSeries',
    controller: GroupStatesSeriesController,
    template: require('./groupStatesSeries.component.html'),
    controllerAs: 'vm',
    bindings: {
        groups: '<',
        isBindable: '=',
        series: '='
    }
};